import {createSlice, type PayloadAction} from '@reduxjs/toolkit';

import type {AppEntry} from '@/consts/appEntries';

export type AppPadding = {
    top?: number;
    bottom?: number;
    bottomMenu?: number;
};

type AppState = {
    marketCode: string;
    languageCode: string;
    isInitialized: boolean;
    padding: AppPadding;
    activeModule: AppEntry | null;
};

const getInitialState = (): AppState => {
    return {
        marketCode: '',
        languageCode: '',
        isInitialized: false,
        padding: {},
        activeModule: null,
    };
};

export const slice = createSlice({
    name: 'app',
    initialState: getInitialState(),
    reducers: {
        setMarketCode: (state, action: PayloadAction<string>) => {
            return {...state, marketCode: action.payload};
        },
        setLanguageCode: (state, action: PayloadAction<string>) => {
            return {...state, languageCode: action.payload};
        },
        setInitialized: (state, action: PayloadAction<boolean>) => {
            return {...state, isInitialized: action.payload};
        },
        setPadding: (state, action: PayloadAction<AppPadding>) => {
            return {...state, padding: action.payload};
        },
        setActiveModule: (state, action: PayloadAction<AppEntry>) => {
            return {...state, activeModule: action.payload};
        },
    },
});

export const {setMarketCode, setLanguageCode, setInitialized, setPadding, setActiveModule} = slice.actions;
export default slice.reducer;
